module.exports = __webpack_public_path__ + "img/close.2c3c221f.svg";